import { scope } from '#components/generics/js/selectors/scope.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import * as utilities from '#utilities/js/styles.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import { modifiers } from '#components/generics/js/styles.js'

// Currently only for class and data attributes but can be extended to other selectors
const countElements = (({ container, element_counter }) => {
  const { class: elementCounterClass, data_selectors: elementCounterScopeJsonSelectors } = element_counter
  let selectors = []

  if (elementCounterClass?.length) {
    const classSelectors = elementCounterClass.map(className => `.${className}`).join('')
    selectors.push(classSelectors)
  }

  if (elementCounterScopeJsonSelectors?.length) {
    const dataSelectors = elementCounterScopeJsonSelectors.map(attr => attr).join('')
    selectors.push(dataSelectors)
  }

  return all(selectors.join(''), container).length
})

export const displayCounter = (container => {
  queueMicrotask(async () => {
    const { dataset, ownerDocument } = container
    const { body } = ownerDocument
    const { elementCounterUid } = dataset
    const { element_counter } = scope(container)
    const counterDisplayer = await inserted(one(`[data-element-counter-displayer='${elementCounterUid}']`), body)
    const result = countElements({ container, element_counter })
    const counterDisplayerContainer = one(`[data-element-counter-displayer-container='${elementCounterUid}']`, ownerDocument)

    if (result > 0) {
      // @todo que faire pour les différentes langues? Enlever ce texte et juste garder le "+X" ?
      const text = result > 1 ? element_counter.text.plural : element_counter.text.singular

      counterDisplayerContainer.classList.remove(utilities.modifiers.display.none)
      counterDisplayer.textContent = `+ ` + result

      if (getComputedStyle(counterDisplayer).getPropertyValue('--ea_element_counter_show_full_text') === 'true') {
        counterDisplayer.textContent += ` ${text}`
      }
    } else if (!counterDisplayerContainer.classList.contains(modifiers.collapse_panel.open)) {
      counterDisplayerContainer.classList.add(utilities.modifiers.display.none)
    }
  })
})

export default container => {
  displayCounter(container)
}
